"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _UnknownTooltip = _interopRequireDefault(require("./UnknownTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function HeldLicenseModify(row) {
  var targetEntity = (0, _get2["default"])(row, 'targetEntity');
  var from = (0, _get2["default"])(row, 'metadata.previousQuantity');
  var to = (0, _get2["default"])(row, 'quantity') || (0, _get2["default"])(row, 'metadata.quantity');
  if (targetEntity && from !== null && to !== null) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Admin modified number of licenses from ", from, " to ", to, " for ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
  }
  if (targetEntity && to !== null) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Admin set the number of licenses to ", to, " for ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
  }
  if (targetEntity) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Admin modified the number of licenses for ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
  }
  if (from !== null && to !== null) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Admin modified number of licenses from ", from, " to ", to, " for an unknown group", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], {
      type: "Group"
    }));
  }
  if (to !== null) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Admin set the number of licenses to ", to, " for an unknown group", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], {
      type: "Group"
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, "Admin modified the number of licenses");
}
var _default = exports["default"] = HeldLicenseModify;